/**
 * TanStack Query hooks for `payment-hold-threshold-minimum-balance-before-rele`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	paymentHoldThresholdMinimumBalanceBeforeReleQueryKeys,
	type CreatePaymentHoldThresholdMinimumBalanceBeforeReleBody,
	type ListPaymentHoldThresholdMinimumBalanceBeforeReleResponse,
	type PaymentHoldThresholdMinimumBalanceBeforeReleRow,
} from "./api";

export function usePaymentHoldThresholdMinimumBalanceBeforeReleList(): UseQueryResult<ListPaymentHoldThresholdMinimumBalanceBeforeReleResponse, Error> {
	return useQuery({
		queryKey: paymentHoldThresholdMinimumBalanceBeforeReleQueryKeys.list(),
		queryFn: list,
	});
}

export function usePaymentHoldThresholdMinimumBalanceBeforeReleCreate(): UseMutationResult<PaymentHoldThresholdMinimumBalanceBeforeReleRow, Error, CreatePaymentHoldThresholdMinimumBalanceBeforeReleBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: paymentHoldThresholdMinimumBalanceBeforeReleQueryKeys.all });
		},
	});
}

export function usePaymentHoldThresholdMinimumBalanceBeforeReleDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: paymentHoldThresholdMinimumBalanceBeforeReleQueryKeys.all });
		},
	});
}
